import React from "react";
import { Form } from "react-bootstrap";
import Editor from "react-simple-wysiwyg";

const EventAdvanceOption = ({
  register,
  errors,
  setEventData,
  setValue,
  eventData,
  getValues,
}) => {
  const handleParkingInstructions = (e) => {
    const val = e.target.value;

    setEventData({ ...eventData, parkinginstructions: val });
    setValue("parkinginstructions", val);
  };
  const handleHealthSafetyInfo = (e) => {
    const val = e.target.value;

    setEventData({ ...eventData, healthSafetyInfo: val });
    setValue("healthSafetyInfo", val);
  };
  return (
    <React.Fragment>
      <div>
        <h2>You are almost done with creating your event</h2>
        <Form.Group controlId="parkinginstructions" className="mb-3">
          <Form.Label>Parking Instructions</Form.Label>
          <Editor
            style={{ height: "200px" }}
            value={eventData?.parkinginstructions}
            onChange={handleParkingInstructions}
          />
          {errors.parkinginstructions && (
            <span className="text-danger">
              {errors.parkinginstructions?.message}
            </span>
          )}
        </Form.Group>
        <Form.Group controlId="healthSafetyInfo" className="mb-3">
          <Form.Label>Health & Safety Guidelines</Form.Label>
          <Editor
            style={{ height: "200px" }}
            value={eventData?.healthSafetyInfo}
            onChange={handleHealthSafetyInfo}
          />
          {errors.healthSafetyInfo && (
            <span className="text-danger">
              {errors.healthSafetyInfo?.message}
            </span>
          )}
        </Form.Group>
      </div>
    </React.Fragment>
  );
};

export default EventAdvanceOption;
